import { render, staticRenderFns } from "./index.vue?vue&type=template&id=db894dba"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db894dba')) {
      api.createRecord('db894dba', component.options)
    } else {
      api.reload('db894dba', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=db894dba", function () {
      api.rerender('db894dba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vip/vipCurrentLevelClassInfo/index.vue"
export default component.exports